export default __webpack_public_path__ + "static/media/motorcycle.e616d9f3.png";